module.exports = __webpack_public_path__ + "img/debora-mirabal.58f057a4.jpg";